/**
 * 콤마가 표기된 문자로 반환
 * @example withComma(1000000) -> '1,000,000'
 */
export function withComma(value) {
    let valueStr;
    if (typeof value === "string") {
        valueStr = value.trim();
    }
    else if (typeof value === "undefined") {
        valueStr = "";
    }
    else {
        valueStr = value.toString();
    }
    return valueStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/**
 * 콤마를 제거하여 숫자로 반환
 * @example noComma('1,000,000') -> 1000000
 */
export function noComma(value) {
    let valueStr;
    if (typeof value === "string") {
        valueStr = value.trim();
    }
    else if (typeof value === "undefined") {
        valueStr = "";
    }
    else {
        valueStr = value.toString();
    }
    return Number(valueStr.replaceAll(",", ""));
}
